(() => {
  const FORM_SELECTOR = '[data-native-form-success]';
  const VALUE_SELECTOR = '[data-native-form-success-value]';
  const TARGET_SELECTOR = '[data-native-form-success-target]';
  const STORAGE_PREFIX = 'glean-native-form-success';
  const STORED_VALUE_MAX_AGE = 15 * 60 * 1000;
  const initializedForms = new WeakSet();

  const getStorageKey = (form) =>
    `${STORAGE_PREFIX}:${window.location.pathname}:${form.dataset.nativeFormStorageKey || ''}`;

  const getValues = (form) => {
    const values = {};

    form.querySelectorAll(VALUE_SELECTOR).forEach((field) => {
      const placeholder = field.dataset.nativeFormSuccessValue;
      if (!placeholder || !('value' in field)) return;
      values[placeholder] = String(field.value || '').trim();
    });

    return values;
  };

  const applyValues = (template, values) =>
    Object.entries(values).reduce(
      (message, [placeholder, value]) => message.split(placeholder).join(value),
      template
    );

  const restoreSuccessMessage = (form) => {
    const target = form.querySelector(TARGET_SELECTOR);
    const template = form.dataset.nativeFormSuccessTemplate;
    if (!(target instanceof HTMLElement) || !template) return;

    try {
      const storageKey = getStorageKey(form);
      const storedSubmission = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
      const isCurrent = storedSubmission
        && storedSubmission.values
        && typeof storedSubmission.values === 'object'
        && Number.isFinite(storedSubmission.submittedAt)
        && Date.now() - storedSubmission.submittedAt <= STORED_VALUE_MAX_AGE;

      if (isCurrent) target.textContent = applyValues(template, storedSubmission.values);
      window.sessionStorage.removeItem(storageKey);
    } catch (error) {
    }
  };

  const rememberSubmission = (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(FORM_SELECTOR)) return;

    const values = getValues(form);
    if (!Object.keys(values).length) return;

    try {
      window.sessionStorage.setItem(
        getStorageKey(form),
        JSON.stringify({ values, submittedAt: Date.now() })
      );
    } catch (error) {
    }
  };

  const initForm = (form) => {
    if (!(form instanceof HTMLFormElement) || initializedForms.has(form)) return;
    initializedForms.add(form);
    restoreSuccessMessage(form);
  };

  const init = (scope = document) => {
    if (scope instanceof Element && scope.matches(FORM_SELECTOR)) initForm(scope);
    scope.querySelectorAll?.(FORM_SELECTOR).forEach(initForm);
  };

  document.addEventListener('submit', rememberSubmission, true);
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
})();
